module.exports = __webpack_public_path__ + "img/sunrise_3.d96f3b20.png";